
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogRT(): TemplateResult<dialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', {
        'className': 'close',
        'onClick': this.close
    }, _createElement('svg', {
        'width': '13',
        'height': '13',
        'viewBox': '0 0 13 13',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
        'fill': '#FF0000'
    }), _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
        'fill': '#FF0000'
    }), _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
        'stroke': '#FF0000',
        'strokeLinecap': 'round',
        'strokeLinejoin': 'round'
    }), _createElement('path', {
        'fillRule': 'evenodd',
        'clipRule': 'evenodd',
        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
        'stroke': '#FF0000',
        'strokeLinecap': 'round',
        'strokeLinejoin': 'round'
    }))), _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-body' }, [this.vehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n              ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n            ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n            ', _translate(`select_default_value`), '\n          ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '10741'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '10744'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown',
                            'key': '44'
                        }, _createElement('div', { 'className': 'cm_select_toggle-title' }, _translate(`select_title`), ' ', this.title), _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': this.firstSelectedTerm || '',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []))) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, _createElement('p', { 'className': 'search-main-container-title' }, 'FIND THE PARTS YOUR TRUCK NEEDS'), _createElement('p', { 'className': 'search-main-container-description' }, 'SELECT YOUR VEHICLE')), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn--primary',
                'onClick': () => {
                    this.selectVehicle();
                    if (this.name === 'HeaderVehicleWidget_mobile-menu') {
                        window.document.querySelector('.close-mobile-nav.js-nav-control')?.click();
                    }
                },
                'disabled': !this.allowToSetVehicle,
                'role': 'button'
            }, '\n    ', this.name === 'HeaderVehicleWidget' ? 'Search' : 'GO', '\n  '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn--secondary',
                'onClick': this.discardVehicle,
                'disabled': !this.allowToDiscardVehicle,
                'role': 'button'
            }, '\n    ', this.name === 'HeaderVehicleWidget' ? 'Clear Filters' : 'Clear', '\n  ')))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })])));
}
        export const componentNames = ["cm:vehicleWidget"]